import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TreeFilterModalComponent } from './tree-filter-modal/tree-filter-modal.component';
import { TreeNodeRefreshOptions } from '../models/TreeNodeRefreshOptions';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleExpandComponent } from './toggle-expand/toggle-expand.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TreeSearchComponent } from './tree-search/tree-search.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NgTemplateOutlet } from '@angular/common';
import breakpoints from '../../../../../shared/utils/breakpoints';
import { Subject, takeUntil } from 'rxjs';
import { TreeNodeService } from '../../../tree-node.service';

@Component({
  selector: 'app-tree-header-buttons',
  templateUrl: './tree-header-buttons.component.html',
  styleUrls: ['./tree-header-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TreeSearchComponent,
    MatTooltipModule,
    MatIconModule,
    ToggleExpandComponent,
    TranslateModule,
    NgTemplateOutlet,
  ],
})
export class TreeHeaderButtonsComponent implements OnInit, OnDestroy {
  private cd = inject(ChangeDetectorRef);
  private dialog = inject(MatDialog);
  private breakpointObserver = inject(BreakpointObserver);

  protected mobileLayout: boolean;

  @Input() treeNodeService: TreeNodeService;

  private unsubscribe$ = new Subject<void>();

  ngOnInit() {
    this.breakpointObserver
      .observe(breakpoints)
      .pipe(takeUntil(this.unsubscribe$)) // Cant use takeUntilDestroyed here, it can be used only in constructor
      .subscribe({
        next: (breakpoint) => {
          this.mobileLayout = breakpoint.matches;
          this.cd.detectChanges();
        },
      });
  }

  openFilter() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      treeNodeService: this.treeNodeService,
    };
    this.dialog
      .open(TreeFilterModalComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => this.treeNodeService.refresh(TreeNodeRefreshOptions.VIEW));
  }

  refresh() {
    this.treeNodeService.refresh(TreeNodeRefreshOptions.ALL);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
